var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('questions-table',{attrs:{"view":"archived"},on:{"restore-question":_vm.onQuestionRestore},model:{value:(_vm.innerModel),callback:function ($$v) {_vm.innerModel=$$v},expression:"innerModel"}})}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2e5f85d6","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/pages/admin/knowledge-checks/components/archived.vue
// module id = null
// module chunks = 